module.exports = __webpack_public_path__ + "img/img-3-4.2839de48.webp";